import React from 'react'

import { useDialogState } from '../components'

export const withDialogState = (Component: any) => (props: any) => {
  const confirmationDialogState = useDialogState()
  const noteDialogState = useDialogState({ modal: false })

  return <Component confirmationDialogState={confirmationDialogState} noteDialogState={noteDialogState} {...props} />
}
